// extracted by mini-css-extract-plugin
export var aiStarIcon = "_tq-2";
export var container = "_tq-4";
export var dismissButton = "_tq-3";
export var hasPaddingBottom = "_tq-6";
export var last = "_tq-e";
export var scrollbarThumb = "_tq-c";
export var scrollbarTrack = "_tq-b";
export var selected = "_tq-9";
export var spin = "_tq-1";
export var spinning = "_tq-0";
export var suggestionItem = "_tq-d";
export var suggestionsPanel = "_tq-5";
export var tonePill = "_tq-8";
export var tonesContainer = "_tq-7";
export var unselected = "_tq-a";